import React from "react";
import Icon from "@ant-design/icons";
import type { CustomIconComponentProps } from "@ant-design/icons/lib/components/Icon";

const CreditCardSvg = () => (
  <svg
    width='1em'
    height='0.75em'
    viewBox='0 0 20 15'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
  >
    <path
      d='M3.09013 0.550293H16.9096C18.6106 0.550293 20 1.93973 20 3.64043V11.3593C20 13.06 18.6106 14.4495 16.9096 14.4495H3.09013C1.38943 14.4495 0 13.06 0 11.3593V3.64043C0 1.93973 1.38943 0.550293 3.09013 0.550293V0.550293ZM8.72761 11.8076L3.0907 11.7931C2.19935 11.7908 2.20789 10.4432 3.09925 10.4452L8.73615 10.4603C9.62751 10.4626 9.61868 11.8102 8.72761 11.8076ZM11.6967 9.53933L3.0907 9.52481C2.19935 9.5231 2.20789 8.17552 3.09925 8.17695L11.7053 8.19176C12.5966 8.19318 12.5881 9.54104 11.6967 9.53933ZM18.8652 6.65538H1.13484V11.3593C1.13484 12.4335 2.01595 13.3146 3.09013 13.3146H16.9096C17.9841 13.3146 18.8652 12.4335 18.8652 11.3593V6.65538V6.65538ZM1.13484 3.79278H18.8652V3.64043C18.8652 2.56624 17.9838 1.68514 16.9096 1.68514H3.09013C2.01595 1.68514 1.13484 2.56624 1.13484 3.64043V3.79278V3.79278Z'
      fill='#3F3D56'
    />
  </svg>
);

export const CreditCardIcon = (props: Partial<CustomIconComponentProps>) => (
  <Icon component={CreditCardSvg} {...props} />
);
